<div class="col-12 bg-white py-3">
    <h4 class="d-flex common-bene-class-for-translation">Petition Status</h4>
</div>
<div class="col-7">
    <div class="position-relative mt-3 bg-white p-3">
      <!-- <h6>Select task to view Status</h6> -->
      <!-- <p-dropdown inputId="tasktype" [options]="subTaskList" [(ngModel)]="selectedTaskTypeCode" class="w-50"
        placeholder="Select Task Type" optionLabel="taskTypeName" optionValue="taskTypeCode"
        (onChange)="getStatusMap()"></p-dropdown> -->
      <p-chart responsive="true" type="doughnut" [data]="chartData" [options]="chartOption" class="piechart"></p-chart>
        <h2 *ngIf="statusPercentageMap" class="d-inline-block position-absolute" [ngClass]="{'text-primary': selectedChartDataFlag === 'Pending', 'text-success': selectedChartDataFlag === 'Completed',  'text-secondary': selectedChartDataFlag === 'Not Started' }" style="top: 57%;left: 35%;">{{ statusPercentageMap[selectedChartDataFlag] }}%
        </h2>
    </div>
  </div>
